module.exports = __webpack_public_path__ + "assets/img/flag-by.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-by.png
// module id = 55
// module chunks = 0